// extracted by mini-css-extract-plugin
module.exports = {"root":"bz_b","box":"bz_dF","icon":"bz_W","noWrap":"bz_dG","enabled":"bz_dH","checked":"bz_dJ","label":"bz_J","dividerAnimation":"bz_p"};